// Phase 30 — Reusable inline help / how-to component.
// Use it under any page header or option to teach users what the screen does.
//
// Usage:
//   <HelpHint title="Was ist das?" testid="help-aufgaben">
//     Erklärungstext, was die Seite tut, was die Aktionen bedeuten, …
//   </HelpHint>
//
// Visual: a small "Wie funktioniert das?" pill (info-icon + label) that
// expands a soft-amber panel with the explanation. Mobile-friendly and
// works in both light and dark mode.

import { useState } from "react";
import { Info, ChevronDown, ChevronUp } from "lucide-react";

export default function HelpHint({
  title = "Wie funktioniert das?",
  children,
  defaultOpen = false,
  className = "",
  testid = "help-hint",
}) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div
      className={`rounded-lg border border-amber-500/30 bg-amber-500/5 ${className}`}
      data-testid={testid}
    >
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        data-testid={`${testid}-toggle`}
        className="w-full flex items-center justify-between gap-2 px-3 py-2 text-left"
      >
        <span className="inline-flex items-center gap-2 text-amber-300 dark:text-amber-300 text-amber-700">
          <Info className="w-4 h-4 shrink-0" />
          <span className="text-xs font-semibold tracking-wide uppercase">
            {title}
          </span>
        </span>
        {open ? (
          <ChevronUp className="w-4 h-4 text-amber-400" />
        ) : (
          <ChevronDown className="w-4 h-4 text-amber-400" />
        )}
      </button>
      {open && (
        <div
          className="px-3 pb-3 pt-0 text-xs leading-relaxed text-zinc-200 dark:text-zinc-200 text-zinc-700 space-y-2"
          data-testid={`${testid}-content`}
        >
          {children}
        </div>
      )}
    </div>
  );
}
